import React from 'react';
import { Container } from 'components/UI';
import IntroDefault from './IntroDefault';
import { getMeetupDateString } from 'utils';
import { MEETUP_TIME } from 'define';

import * as styles from './Intro.module.scss';

export default function Intro(props) {
  const preparedProps = {
    ...props,
    date: getMeetupDateString(),
    time: MEETUP_TIME,
  };

  return (
    <Container className={styles.container} background="transparent">
      <IntroDefault {...preparedProps} />
    </Container>
  );
}
